import { whiteColor, infoColor, infoBoxShadow } from '../global';

const style = (theme) => ({
    wrapper: {
        backgroundColor: whiteColor,
    },
    eventInfo: {
        paddingTop: '12px',
        paddingBottom: '12px',
    },
    formInputInformation: {
        border: '1px solid',
        borderColor: infoColor,
        borderRadius: '8px',
        ...infoBoxShadow,
        padding: '20px',
        maxWidth: '1000px',
        marginLeft: 'auto',
        marginRight: 'auto',
        [theme.breakpoints.down('md')]: {
            marginLeft: '15px',
            marginRight: '15px',
            width: 'calc(100% - 30px)',
        },
    },
    spacing: {
        padding: '15px 0',
    },
    errorText: {
        margin: '4px 14px 0',
    },
    detailWrapper: {
        whiteSpace: 'pre-line',
        wordBreak: 'break-all',
    },
    radioButton: {
        fontSize: '14px',
    },
    currencyInput: {
        '& input': {
            padding: '9px',
            width: '333px',

            '&::-webkit-inner-spin-button': {
                opacity: 1, // Always show spin buttons on Chrome
            },
        },
    },
    numberInput: {
        width: '150px',
    },
    price: {
        '&:after': {
            content: '"円"',
            transform: 'translateX(calc(100% + 10px))',
        },
    },
});

export default style;
